<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>

    <!--    점검대상-->
    <!--    <vs-row class="mt-6">-->
    <!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
    <!--        <h5>-->
    <!--          <i class="dot"></i> 점검대상-->
    <!--        </h5>-->
    <!--      </vs-col>-->
    <!--    </vs-row>-->

    <!--    <div class="gap-x-6 gap-y-4 mt-4">-->
    <!--      <p v-if="isPrint" class="print-input"> {{form.inspectionTitle}} </p>-->
    <!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
    <!--        <vs-checkbox-->
    <!--          class="mr-1 mb-2"-->
    <!--          :readonly="board.readonly">-->
    <!--          {{form.inspectionTitle}}-->
    <!--        </vs-checkbox>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    청소·조도·통로 등-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    관련서식-->
    <vs-row class="mt-6 mb-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 관련서식</h5>
      </vs-col>
    </vs-row>

    <file-upload-module
      id="formList"
      class="w-full mb-4"
      v-model="form.formList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      :visible-title="false"
      :customTitle="true"
    ></file-upload-module>

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full"
      v-model="form.fileList"
      :isPrint="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import TableEquipment from "@/components/TableEquipment";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";

export default {
  components: {
    DisasterClassSelector,
    TableInspect,
    FileUploadModule,
    TableEquipment,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
        this.form.inspectionTitle = this.inspectionTitle;
        if (
          !this.form ||
          !this.form.inspectList ||
          this.form.inspectList.length === 0
        ) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "청소·조도·통로 등",
      form: {
        inspectionTitle: "청소·조도·통로 등",
        stdInfo: {},
        photoList: [],

        formList: [],
        fileList: [],
        equipmentList: [],
        inspectList: [],
      },
    };
  },
  computed: {
    inspectTable() {
      return [
        {
          id: 1,
          title: "청소",
          label:
            "작업자가 넘어지거나 미끄러지는 등의 위험이 없도록 바닥 등을 안전하고 청결하게 유지한다.",
          is_checked: "",
        },
        {
          id: 2,
          title: "조도",
          label:
            "작업자가 작업하는 장소 및 통로에 알맞은 조도를 확보하고, 상시 통행을 하지 않는 곳에는 휴대용 조명기구를 사용하도록 관리한다.",
          is_checked: "",
        },
        {
          id: 3,
          title: "통로",
          label:
            "작업자가 안전하게 이동할 수 있도록 공정 변화에 맞춰 사전에 통로 확보 방안을 검토하여 설치한다.",
          is_checked: "",
        },
        {
          id: 4,
          title: "통로",
          label:
            "가설통로를 설치하는 경우에는 견고하고 미끄러지지 않게 설치하고, 설치상태를 수시로 점검한다. \n" +
            "      *가설통로 설치기준 : 견고한 구조, 경사는 30도 이하(계단을 설치하거나 높이 2미터 미만의 가설통로로서 손잡이 설치한 경우 제외), 경사가 15도를 초과하는 경우\n" +
            "       미끄러지지 아니하는 구조 등",
          is_checked: "",
        },
        {
          id: 5,
          title: "통로",
          label:
            "사다리식 통로를 설치하는 경우 설치기준*에 맞게 설치하고, 설치상태를 수시로 점검한다. \n" +
            "       *사다리식 통로 설치기준 : 견고한 구조, 손상·부식 등이 없는 재료 사용, 사다리가 넘어지거나 미끄러짐 방지를 위한 조치 등",
          is_checked: "",
        },
        {
          id: 6,
          title: "통로",
          label:
            "비상시 작업장 내에서 탈출할 수 있는 비상구가 적절히 마련되어 있으며, 비상구 표시가 작업자 눈에 띄기 쉬운 곳에 부착되어 있다.",
          is_checked: "",
        },
        {
          id: 7,
          title: "통로",
          label:
            "비상구·비상통로 또는 비상용 기구를 쉽게 이용할 수 있도록 유지하고, 연면적 400제곱미터 이상 또는 상시 50명 이상 작업하는 옥내작업장의 경우 비상시 신속하게\n" +
            "       알리기 위한 경보용 설비·기구가 설치되어 있다.",
          is_checked: "",
        },
        {
          id: 8,
          title: "보호구",
          label:
            "작업조건에 맞는 보호구를 지급하고, 착용여부를 수시로 점검한다.",
          is_checked: "",
        },
        {
          id: 9,
          title: "보건관리",
          label:
            "열사병, 한랭질환 등 건설현장 작업자의 계절성 질병을 예방하기 위해 적절한  휴식시간, 휴게시설 등을 제공한다.",
          is_checked: "",
        },
      ];
    },
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateListCheck(indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
